import React from 'react';
import { FaCheckCircle, FaMoneyBillWave, FaBolt, FaGlobe, FaBox, FaHandshake } from 'react-icons/fa';

const whyData = [
  { icon: <FaCheckCircle />, title: 'Genuine Parts Only', desc: '100% OEM genuine American automotive parts. No counterfeit, no compromises.' },
  { icon: <FaMoneyBillWave />, title: 'Competitive Wholesale Prices', desc: 'Volume-based pricing designed for dealers, importers, and fleet operators worldwide.' },
  { icon: <FaBolt />, title: 'Fast Response', desc: '24-hour response time on all inquiries. Your business moves at the speed of trust.' },
  { icon: <FaGlobe />, title: 'Global Export Experience', desc: 'Exporting to 40+ countries with seamless logistics and customs expertise.' },
  { icon: <FaBox />, title: 'Reliable Supply Chain', desc: 'Strategic inventory and supply network ensuring consistent availability.' },
  { icon: <FaHandshake />, title: 'Professional Customer Service', desc: 'Dedicated support team with deep industry knowledge and a commitment to excellence.' },
];

const WhyChooseUs = () => {
  return (
    <section className="why" id="why">
      <div className="container">
        <div className="section-header reveal">
          <span className="label">Why Choose Us</span>
          <h2>Built on <span className="highlight">Trust</span> &amp; Excellence</h2>
          <p>Every partnership begins with reliability. Here's why global buyers choose AUTO EXPERTS FZE.</p>
        </div>

        <div className="why-grid">
          {whyData.map((item, index) => (
            <div key={index} className={`why-card reveal reveal-delay-${(index % 5) + 1} glass-reflection`}>
              <div className="icon-wrapper">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;